const idCardTypePH = {
  taxpayerIdentificationNumber: '纳税人识别号',
  socialSecuritySystem: '社会保障体系',
  governmentServiceInsuranceSystem: '政府服务保险制度',
};

export default idCardTypePH;
